import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  charts: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.CHART__STATE_UPDATED:
      return {
        ...state,
        charts: {
          ...state.charts,
          [action.payload.urn]: action.payload.state,
        },
      };

    case AppConstants.CARD__LOAD_STATE_FROM_VIEW_FINISHED: {
      const {cardId, chartState} = action.payload;

      return {
        ...state,
        charts: {
          ...state.charts,
          [cardId]: chartState,
        },
      };
    }

    case AppConstants.CARD__RESET_STATE: {
      const charts = {...state.charts};
      delete charts[action.payload.cardId];

      return {
        ...state,
        charts,
      };
    }
    default:
      return state;
  }
};
